import React,{useRef,createRef} from "react";

import {
    Input,
    Row, Col,
    Card,
    CardBody,
    FormGroup,
    Button,

} from "reactstrap";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import ReactTable from "react-table-legacy";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import _ from "lodash";
import PropTypes from 'prop-types';

const propTypes = {
    pageChangeFunc: PropTypes.func,
}
// 変更内容
// subComponentを外だし
export default class TableTreeForSubComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = this.addAllCheckField({
            default_column: this.props.column ? this.props.column : [],
//            all_column: this.props.all_column ? this.props.all_column : this.props.column ? this.props.column : [],
            column: this.props.column ? this.props.column : [],
            data: this.props.data ? this.props.data : [],
            detail_search: false,
            tmp_column: [],
            sub_column: this.props.sub_column ? this.props.sub_column : [],
            thr_column: this.props.thr_column ? this.props.thr_column : [],
            with_all_check: this.props.with_all_check ? this.props.with_all_check : false,
            all_check: false,
            show_detail_search_field: this.props.show_detail_search_field ? true : false,
            show_column_select_area: this.props.show_column_select_area?  false : true,
            mode: this.props.mode ? this.props.mode : 0, // 0: その他大勢 1: 調査詳細モード
            count: this.props.count? this.props.count:0,
            perPage: this.props.perPage? this.props.perPage:50,
            pageIndex: this.props.pageIndex? this.props.pageIndex: 0,
            perPage_options:[5,10,20,25,50,100],
            sortOptions:this.props.defaultSortedColumn?this.props.defaultSortedColumn:[],
            subComponent:this.props.subComponent? this.props.subComponent: this.nothingSubComponent,
        });

        // this.addAllCheckField = this.addAllCheckField.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);
        this.setReactTableColumn = this.setReactTableColumn.bind(this);
        this.allCheckChanged = this.allCheckChanged.bind(this);
        this.updateChecked = this.updateChecked.bind(this);
        this.targettedDefaultColumn = this.targettedDefaultColumn.bind(this);

        /* 2021/06/08 scroll to list top */
        this.currentRef = createRef();
        this.pageChange = this.pageChange.bind(this);
        this.addViewColumn = this.addViewColumn.bind(this); // #1198

        /* 2021/07/19 out of 1000 limit */        
        this.pagingHeader = this.pagingHeader.bind(this);
        this.nextView = this.nextView.bind(this);
        this.beforeView = this.beforeView.bind(this);
        this.changePerPage = this.changePerPage.bind(this);

        this.pageHeaderRef = createRef();
        this.pageFooterRef = createRef();
        this.pageLimitHeaderRef = createRef();
    }

    nothingSubComponent = (row) => {        
        return null
    }

    // #1198
    addViewColumn () {
        let localStrageColumns;

        if (localStrageColumns = GsuiteAuth.get("all_column__" + this.props.page_id)) {
            const parseColumns = JSON.parse(localStrageColumns);
            let ret = this.state.default_column.filter((col)=>{
                let matches = parseColumns.filter(parse_col=>parse_col.accessor == col.accessor);
                if ( matches.length == 0 ) {
                    return col;
                }
            });
            if (ret.length > 0) {
                GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            }
            return ret;
        }
        else {
            GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            return this.state.default_column.filter((col)=>col.add_flg == true);
        }
    }

    UNSAFE_componentWillMount() {
        let column = _.map(this.state.default_column,(data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });

        let addColumns = this.addViewColumn();
        let viewColumn = (this.props.page_id&&GsuiteAuth.get(this.props.page_id))? JSON.parse(GsuiteAuth.get(this.props.page_id)).concat(addColumns) : column;

        this.setState({
            column: column,
            tmp_column: viewColumn,
        }, ()=>this.setReactTableColumn())
    }

    addAllCheckField(state) {
        // let buf = state;
        if (state.with_all_check) {
            // let column = Array.from(buf.column);
            let column = state.column;
            if(_.find(column, (item) => { return item.allCheckField; }) === undefined) {
                column.unshift({ Header: <input type="checkbox" name="all_check" onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true });
            }
            state.column = column;
            state.default_column = column;
        }
        return state
    }

    allCheckChanged(e) {
        let data = _.map(this.state.data, (item) => {
            item.checked = e.target.checked;
            return item;
        });
        this.setState({ all_check: true, data: data }, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback() });
    }

    componentDidMount(){
        // let ps;
        // let tables = document.querySelectorAll(".rt-table");
        // for (let i = 0; i < tables.length; i++) {
        //     ps = new PerfectScrollbar(tables[i]);
        // }
    }

    componentDidUpdate(prevProps) {
        if ( this.props.count != this.state.count && !isNaN(this.props.count)) {
            this.setState({count: this.props.count });
        }
        if ( this.props.pageIndex != this.state.pageIndex && !isNaN(this.props.pageIndex )) {
            this.setState({pageIndex: this.props.pageIndex });
        }

        if ( this.pageHeaderRef.current ) {
            this.pageHeaderRef.current.value = this.state.pageIndex + 1;
            this.pageLimitHeaderRef.current.value = this.state.perPage;
        }

        if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
            return;

        this.setState(this.addAllCheckField({
            ...this.state,
            data:this.props.data
        }));

        // let state = Object.create(this.state);
        // state.data = this.props.data ? this.props.data : [];
        // this.setState(this.addAllCheckField(state));
    }

    targettedDefaultColumn() {
        return this.state.default_column.filter((item) => { return !item.nonTargetFilter; });
    }

    //テーブル定義用
    handleColumnChange(e) {
        var column = [];

        _.each(this.state.default_column, (item) => {
            if(item.nonTargetFilter) {
                column.push(item);
            }
        });
        let targetted_default_column = this.targettedDefaultColumn();
        _.each(e.target, (item) => {
            if (!item.nonTargetFilter && item.selected) {
                column.push(targetted_default_column[item.value]);
            }
        });
        this.setState({ tmp_column: column });
    }

    setReactTableColumn(e) {
        const t_column = this.state.tmp_column.map((item) => {
            item.show=true
            const columnData = this.state.default_column.find(element=>element.accessor == item.accessor)
            return {
                ...item,
                ...columnData,
            }
        });
        this.setState({ column:  t_column});
        GsuiteAuth.set(this.props.page_id, JSON.stringify(this.state.tmp_column))
    }

    updateChecked(e, idx) {
        let data = _.map(this.state.data, (element, index, array) => {
            if (idx === index) {
                element.checked = e.target.checked;
            }
            return element;
        });
        this.setState({ data: data }, this.props.checkedChangeCallback && this.props.checkedChangeCallback());
    }

    columnSelectArea() {
        if (this.state.mode === 1)
            return (<></>);
        else
            return (
                <>
                    <Row>
                        {this.state.show_detail_search_field && <Col md="2">
                            <div id="detailed-search-button">
                            <ButtonWithTooltip
                                onclick={() => { this.setState({ detail_search: !this.state.detail_search }); }} 
                                class="" 
                                id="detail" 
                                icon="fas fa-angle-down" 
                                label="詳細検索" 
                                message="詳細検索を表示します。" />
                            </div>
                        </Col>}
                        {this.props.custom_field1 != null && <Col md="2">
                            {this.props.custom_field1}
                        </Col>}
                        {this.state.show_column_select_area && <Col md="2">
                            <ButtonWithTooltip
                                onclick={() => { this.setState({ column_select_area_visible: !this.state.column_select_area_visible }); }}
                                class=""
                                id="tmp"
                                icon="fas fa-angle-down"
                                label="表示設定"
                                message="テーブルの表示設定を変更出来ます。"
                            />
                        </Col>}
                        <Col md="8">
                            {this.props.add_button_field}
                        </Col>
                    </Row>
                    <br />
                    <Row className={this.state.detail_search ? 'on' : 'off'}>
                        <Col md="12" className="margin-auto">
                            <Card>
                                <CardBody className={"search-box"}>
                                <Row>
                                {this.props.detail_search_field}
                                </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className={this.state.column_select_area_visible ? 'on' : 'off'}>
                        <Col md="12" className="margin-auto">
                            <Card>
                                <CardBody className={"search-box"}>
                                    <Row>
                                        <Col md="5">
                                            <FormGroup>
                                                <Input type="select" name="column" id="column" onChange={this.handleColumnChange} multiple={true}>
                                                    {this.targettedDefaultColumn().map((data, index) => (
                                                        <option key={index} value={index}>{data.headerLabel ? data.headerLabel : data.Header}</option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3">
                                            <Button type="button" color="default" onClick={this.setReactTableColumn}>反映</Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </>
            );
    }
    syncData () {
        return this.state.data;
    }

    pageChange( pageNum ){
        var setPageIndex = this.validPageNum(pageNum);

        if ( setPageIndex == this.state.pageIndex ) {
            return;
        }
        
        this.setState({pageIndex:setPageIndex});

        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":setPageIndex,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
    }

    validPageNum ( pageNum ) {
        var setPageIndex = Number(pageNum) - 1;
        var pageCount = Math.ceil(this.state.count / this.state.perPage);
        if (setPageIndex < 0) {
            setPageIndex = 0;
        }
        else if (pageCount <= setPageIndex) {
            setPageIndex = pageCount - 1;
            if(setPageIndex < 0){
                setPageIndex = 0;
            }
        }
        return setPageIndex;
    }

    pagerPressEnter ( event ) {
        if ( event.key == "Enter" ) {
            this.pageChange(event.target.value);
        }
    }

    changePerPage (perPage) {
        // this.setState({perPage:perPage,pageIndex:0});
        if ( this.props.limitChangeFunc != undefined ) {
            this.props.limitChangeFunc( perPage );
        }
        this.setState({perPage: parseInt(perPage),pageIndex:0});
    }

    pagingHeader (refKey = "header") {
        // var count = (this.state.count)? this.state.count: 0
        // var page = (this.state.pageIndex)?this.state.pageIndex + 1: 1
        // var pageCount = (this.state.count && this.state.perPage)? Math.ceil(this.state.count / this.state.perPage): 0
        var pageCount = Math.ceil(this.state.count / this.state.perPage);
        return (<>
        <div class="ReactTable">
            <div class="pagination-top">
                <div class="-pagination">
                    <div class="-previous">
                    {this.state.pageIndex==0 ? (<>
                        <button type="button" class="-btn" disabled="disabled" onClick={this.beforeView}>前へ</button>
                    </>):(<>
                        <button type="button" class="-btn" onClick={this.beforeView}>前へ</button>
                    </>)}
                    </div>
                    <div class="-center">
                        <span class="-pageInfo"> 
                            <div class="-pageJump">
                                {/* <input aria-label="jump to page" type="number" value={page} /> */}
                                {refKey == "header"?(<>
                                    <input aria-label="jump to page" type="number" ref={this.pageHeaderRef} defaultValue={this.state.pageIndex + 1} onBlur={(e)=>{this.pageChange(e.target.value)}} onKeyPress={(e)=>{this.pagerPressEnter(e)}} />
                                </>):(<>
                                    <input aria-label="jump to page" type="number" ref={this.pageFooterRef} defaultValue={this.state.pageIndex + 1} onBlur={(e)=>{this.pageChange(e.target.value)}} onKeyPress={(e)=>{this.pagerPressEnter(e)}} />
                                </>)}
                            </div> / <span>{pageCount} （計{this.state.count}件）</span>
                        </span>
                        <span class="select-wrap -pageSizeOptions">
                            <select aria-label="rows per page" ref={this.pageLimitHeaderRef} onChange={(e)=>{this.changePerPage(e.target.value)}}>
                                {this.state.perPage_options.map((i) => {
                                    return (<>
                                    {this.state.perPage == i?(<><option value={i} selected>{i} 件表示</option></>):(<><option value={i}>{i} 件表示</option></>)}
                                    </>);
                                })}
                            </select>
                        </span>
                    </div>
                    <div class="-next">
                    {pageCount == 0 || (this.state.pageIndex + 1)==pageCount ? (<>
                        <button type="button" class="-btn" disabled="disabled" onClick={this.nextView}>次へ</button>
                    </>):(<>
                        <button type="button" class="-btn" onClick={this.nextView}>次へ</button>
                    </>)}
                    </div>
                </div>
            </div>
        </div>
        </>);
    }

    nextView () {
        var p = this.state.pageIndex + 1;

        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":p,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
        this.setState({pageIndex:p});

    }
    beforeView () {
        var p = this.state.pageIndex - 1;
        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":p,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
        this.setState({pageIndex:p});
    }

    getTrProps=(state, rowInfo, column) => {
        if (rowInfo) {
            if (this.state.data[rowInfo.index]) {
                const bgColor = this.state.data[rowInfo.index].rowColor?this.state.data[rowInfo.index].rowColor:""
                return {
                className: [bgColor]
                };
            }
        }
        return {
            className: [
                ""
            ]
        };
    }

    render() {
        let data = this.state.data;
        if (this.state.with_all_check) {
            data = _.map(this.state.data, (element, index, array) => {
                let new_item = Object.create(element);
                new_item.check = <input type="checkbox" name="item_check" checked={element.checked === true} onChange={(e) => { this.updateChecked(e, index) }} />;
                return new_item;
            });
        }

        let columnSelectArea = this.columnSelectArea();

        return (
            <>
                <CardBody>
                    {columnSelectArea}
                    {this.props.checkbox_field_cols}
                    <br />
                    {this.props.columnSelectUnderArea}
                    <br />
                    <span ref={this.currentRef}></span>
                    {this.pagingHeader()}
                    <div ref={this.currentRef}></div>
                    <ReactTable
                        page={this.props.page}
                        onPageChange={(p)=>{this.props.handlePageUpdate(p);this.pageChange( this );}}
                        sortable={true}
                        sorted={this.state.sortOptions}
                        onSortedChange={val => {
                            this.setState({ sortOptions: val }) }
                        }
                        data={data}
                        columns={this.state.column}
                        defaultPageSize={100}
                        minRows={3}
                        filterable={false}
                        showPaginationTop={false}
                        showPaginationBottom={false}
                        rowsText="件表示"
                        loadingText='読込中…'
                        noDataText='検索してください'
                        pageText=''
                        ofText='/'
                        className="-highlight primary-pagination"
                        getTdProps={(state, rowInfo, column, instance) => {
                            return {
                                onClick: async (e, handleOriginal) => {
                                    if(this.props.clickRowCallback && rowInfo && rowInfo.index !== undefined){
                                        await this.props.clickRowCallback(this.state.data[rowInfo.index], rowInfo.index);
                                        const { expanded } = state;
                                        const path = rowInfo.nestingPath[0];
                                        const diff = { [path]: expanded[path] ? false : true };
                                        instance.setState({
                                            expanded: {
                                                ...expanded,
                                                ...diff
                                            }
                                        });
                                    }
                                    // IMPORTANT! React-Table uses onClick internally to trigger
                                    // events like expanding SubComponents and pivots.
                                    // By default a custom 'onClick' handler will override this functionality.
                                    // If you want to fire the original onClick handler, call the
                                    // 'handleOriginal' function.
                                    if (handleOriginal) {
                                        handleOriginal()
                                    }
                                }
                            }
                        }}
                        getTrProps = {this.getTrProps}
                        onPageSizeChange ={(perPage)=>{
                            this.setState({perPage})
                        }}
                        renderTotalPagesCount= {(pages) => {
                            return <span>{pages<=0?1:pages} （計{this.state.count}件）</span>
                        }}
                        //依頼
                        //SubComponent={(row) => { return this.subc(row)}
                        SubComponent={(row) => { return this.state.subComponent(row)}}
                        freezeWhenExpanded={false}
                        collapseOnDataChange={false}
                    />
                    <br />
                    <span ref={this.currentRef}></span>
                    {this.pagingHeader()}
                    <div ref={this.currentRef}></div>
                </CardBody>
            </>
        );
    }

    subc = (row) => {        
        return <div>{JSON.stringify(row, null, 2)}</div>
    }
}
TableTreeForSubComponent.propTypes = propTypes;